module.exports = __webpack_public_path__ + "img/26ne.854a3408.svg";